import { makeStyles } from '@material-ui/core/styles';

const useWebPathDetailGraphStyles = makeStyles((theme) => {
    const isDark = theme.palette.type === 'dark';
    const edgeColor = isDark ? '#7a9eb8' : '#5d82a1';
    const nodeStroke = '#3f3f3f';
    const nodeFill = isDark ? '#ffffff' : '#9e9e9e';
    const nodeInnerLabelColor = '#000';
    const destOutlineColor = '#333';
    const destIconFill = isDark ? '#ffffff' : '#AAA';

    return {
        pathDetailWrapper: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 14,
        },

        zoomControls: {
            display: 'flex',
            flexDirection: 'column',
            border: '1px solid #d7dde4',
            borderRadius: 6,
            overflow: 'hidden',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
            marginTop: 8,
            flexShrink: 0,
        },

        zoomButton: {
            width: 34,
            height: 30,
            border: 0,
            background: theme.palette.background.paper,
            cursor: 'pointer',
            fontSize: 22,
            color: '#5f6974',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,

            '&:hover': {
                background: theme.palette.action.hover,
            },
        },

        viewport: {
            flex: 1,
            minWidth: 0,
            overflow: 'hidden',
            minHeight: 220,
        },

        graphContainer: {
            display: 'block',
            fontFamily: 'Roboto, Helvetica, Arial, Verdana, sans-serif',
            marginBottom: 12,

            '& > svg': {
                display: 'block',
                overflow: 'visible',
            },

            // ── Edges ──
            '& .graph-edge': {
                fill: 'none',
                stroke: edgeColor,
                strokeWidth: 3,
            },

            '& .edge-label-outline': {
                fill: theme.palette.background.paper,
                stroke: theme.palette.background.paper,
                strokeWidth: 4,
                fontSize: 12,
                fontWeight: 600,
            },

            '& .edge-label': {
                fill: theme.palette.text.primary,
                fontSize: 12,
                fontWeight: 600,
            },

            // ── Nodes ──
            '& .graph-node': {
                cursor: 'pointer',

                '& .agent-icon': {
                    fill: nodeFill,
                    stroke: nodeStroke,
                    strokeWidth: 2,
                },

                '& .agent-dot': {
                    fill: nodeInnerLabelColor,
                },

                '& .hop-circle': {
                    fill: nodeFill,
                    stroke: nodeStroke,
                    strokeWidth: 2,
                },

                '& .unknown-circle': {
                    fill: '#d4d4d4',
                    stroke: nodeStroke,
                    strokeWidth: 2,
                },

                // Destination icon — matches portal/ui networkGraph .node-outline / .node-icon
                // (material-icons 'storage' glyph, dark stroke + light fill, no rect).
                '& .dest-outline': {
                    fill: 'none',
                    stroke: destOutlineColor,
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    fontSize: 30,
                    pointerEvents: 'none',
                },

                '& .dest-icon': {
                    fill: destIconFill,
                    fontSize: 30,
                    pointerEvents: 'none',
                },

                '& .hop-inner-label': {
                    fill: nodeInnerLabelColor,
                    fontSize: 12,
                    fontWeight: 'normal',
                    pointerEvents: 'none',
                },

                '& .agent-label': {
                    fontSize: 13,
                    fill: theme.palette.text.primary,

                    '& tspan': {
                        fontSize: 13,
                    },
                },

                '& .dest-label': {
                    fontSize: 13,
                    fill: theme.palette.text.primary,
                },
            },
        },
    };
});

export default useWebPathDetailGraphStyles;
